import _ from "lodash";
import { validationMixin } from "vuelidate";

export const FormValidationMixin = {
  name: "FormValidationMixin",
  mixins: [validationMixin],
  props: {
    value: {
      type: [Object, String, Number, Array, Boolean], // Adapt the type based on your use case
      // required: true,
    },
  },
  data() {
    return {
      isError: false,
      errors: [],
      form: this.value,
    };
  },
  watch: {
    errors() {
      this.isError = this.errors.length > 0;
      this.$emit("errors", this.isError);
    },
    form: {
      deep: true,
      handler() {
        this.$emit("input", this.form);
      },
    },
    value() {
      this.form = this.value;
    },
  },
  methods: {
    isErrorField(field, isValidationField = false) {
      try {
        const validationField = isValidationField ? field : this.getValidationField(field);
        if (validationField.$error) {
          if (!isValidationField) {
            this.addFormError(field, null);
          }
          return true;
        }
      } catch (error) {
        throw error;
      }
      return this.errors.some((el) => el.field === field);
    },
    getFieldClasses(field) {
      return { "is-invalid": this.isErrorField(field) };
    },
    getCharactersLeft(field) {
      try {
        return (
          this.getValidationField(field).$params.maxLength.max - (this.form[field]?.length ?? 0)
        );
      } catch (error) {
        return 0;
      }
    },
    getMaxLength(field) {
      try {
        return this.getValidationField(field).$params.maxLength.max;
      } catch (error) {
        return 0;
      }
    },
    getMinValue(field) {
      try {
        return this.getValidationField(field).$params.minValue.min;
      } catch (error) {
        return 0;
      }
    },
    getMaxValue(field) {
      try {
        return this.getValidationField(field).$params.maxValue.max;
      } catch (error) {
        return 0;
      }
    },
    getValidationField(field) {
      if (this.$v.form && this.$v.form[field]) {
        return this.$v.form[field];
      }
      if (_.get(this.$v, field)) {
        return _.get(this.$v, field);
      }
      throw Error(`No validation for field ${field}`);
    },
    onFieldChange(field, isValidationField = false) {
      if (this.isErrorField(field, isValidationField)) {
        this.onFieldBlur(field, isValidationField);
      }
    },
    onFieldBlur(field, isValidationField = false) {
      try {
        const validationField = isValidationField ? field : this.getValidationField(field);
        validationField.$touch();
        if (validationField.$error) {
          if (!isValidationField) {
            this.addFormError(field, null);
          }
          return true;
        }
        if (!isValidationField) {
          this.removeFormError(field);
        }
        return false;
      } catch (error) {
        throw error;
      }
    },
    addFormError(field, msg) {
      if (!this.errors.some((el) => el.field === field)) {
        this.errors.push({ field, message: msg });
      }
    },
    removeFormError(field) {
      this.errors = this.errors.filter((el) => el.field !== field);
    },
  },
  mounted() {
    if (this.value) {
      this.form = this.value;
    }
  },
};
